<template>
  <div>
    <div class="l-block__infoarea">
      <img src="@/assets/img/ico-information.svg" alt="" />
      「新規コンテンツ作成」のタスク完了したコンテンツが表示されます。
    </div>
    <div class="l-block__content u-pt20">
      <Loading
        v-if="isLoadingTasksNewContent || isLoadingRankedContentsSummary"
      />
      <template
        v-if="!isLoadingTasksNewContent && !isLoadingRankedContentsSummary"
      >
        <div
          class="l-block__graphArea--left l-block__graphArea--newContentsSummary"
        >
          <TitleSub level="h4">
            <span class="title">順位がついたコンテンツ／公開済み</span>
            <Tooltip size="sm">
              「新規コンテンツ作成」のタスク完了したコンテンツ数と、そのうち検索順位チェックに登録して順位がついたコンテンツ数が表示されます。
            </Tooltip>
          </TitleSub>
          <div class="c-section__newContentsSummary">
            <template v-if="isEmpty">
              <span class="hasRank zero">0</span>
              <hr />
              <span class="total zero">0</span>
            </template>
            <template v-else>
              <span class="hasRank">{{ rankedContentsCount }}</span>
              <hr />
              <span class="total">{{ tasks.length }}</span>
            </template>
          </div>
        </div>

        <div class="l-block__graphArea--right">
          <div class="l-block__graphArea__title">
            <h4 class="c-title c-title--h04">コンテンツ数の推移</h4>

            <ul class="c-graph-legend">
              <li
                class="c-graph-legend__item c-graph-legend__item--newContents"
              >
                公開済みコンテンツ
              </li>
            </ul>
          </div>

          <GraphTermNewContents
            :data="termData"
            :period="period"
            :isEmpty="isEmpty"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import Loading from '@/components/Loading';
import TitleSub from '@/components/TitleSub';
import Tooltip from '@/components/Tooltip';
import GraphTermNewContents from '@/components/dashboard/GraphTermNewContents';
import utils from '@/utils';

export default {
  props: {
    tasks: {
      type: Array,
      required: true
    },
    isLoadingTasksNewContent: {
      type: Boolean,
      required: true
    },
    isLoadingRankedContentsSummary: {
      type: Boolean,
      required: true
    },
    rankedContentsSummary: {
      type: Object,
      required: true
    }
  },

  watch: {
    tasks: {
      handler() {
        this.termData = this.createTermData();
      },
      immediate: true
    }
  },

  computed: {
    isEmpty() {
      // タスクが0件かどうかの判定
      if (!this.tasks || this.tasks.length == 0) {
        return true;
      } else {
        return false;
      }
    },
    // 「順位がついたコンテンツ/公開済みコンテンツ」で順位がついたコンテンツの方が大きくならないように調整
    rankedContentsCount() {
      if (this.rankedContentsSummary.rankedContentsCount > this.tasks.length) {
        return this.tasks.length;
      }
      return this.rankedContentsSummary.rankedContentsCount;
    }
  },

  data() {
    return {
      period: [],
      termData: []
    };
  },

  created() {
    // 環境がdemoの場合はデモ用の表示期間で固定するようにする
    if (process.env.VUE_APP_ENV === 'demo') {
      // GSCのデモ用の期間を仕様
      let to = utils.getGADemoPeriod('all')[1];
      to = utils.getStartDate(to, 'month');
      let from = utils.getDateResetHours(to);
      from.setFullYear(from.getFullYear() - 1);
      from.setMonth(from.getMonth() + 1);
      this.period = [from, to];
    } else {
      let to = utils.getDateResetHours();
      to.setDate(to.getDate() - 1);
      to = utils.getStartDate(to, 'month');
      let from = utils.getDateResetHours(to);
      from.setFullYear(from.getFullYear() - 1);
      from.setMonth(from.getMonth() + 1);
      this.period = [from, to];
    }

    this.termData = this.createTermData();
  },

  components: {
    Loading,
    TitleSub,
    Tooltip,
    GraphTermNewContents
  },

  methods: {
    createTermData() {
      const from = this.period[0];
      const to = this.period[1];

      let d = new Date(from);
      let result = [];

      // fromからtoは12ヶ月。1月ずつループを回す。
      while (d <= to) {
        result.push({
          contentsCount: this.tasks.filter(v => {
            // 月末よりも完了日が手前のものを集計
            return (
              v.typeDoneDate <=
              utils.formatDate(utils.getEndDate(d, 'month'), 'YYYY-MM-DD')
            );
          }).length,
          monthJst: new Date(d)
        });
        // 1ヶ月加算
        d.setMonth(d.getMonth() + 1);
      }

      return result;
    }
  }
};
</script>
